/* eslint-disable no-bitwise */
const VCARD_KEY = 'mcc-hr-vcard-key'
const VCARD_IV = 'mcc-hr-vcard-iv1'

const SBOX = [
  0x63, 0x7c, 0x77, 0x7b, 0xf2, 0x6b, 0x6f, 0xc5, 0x30, 0x01, 0x67, 0x2b, 0xfe, 0xd7, 0xab, 0x76,
  0xca, 0x82, 0xc9, 0x7d, 0xfa, 0x59, 0x47, 0xf0, 0xad, 0xd4, 0xa2, 0xaf, 0x9c, 0xa4, 0x72, 0xc0,
  0xb7, 0xfd, 0x93, 0x26, 0x36, 0x3f, 0xf7, 0xcc, 0x34, 0xa5, 0xe5, 0xf1, 0x71, 0xd8, 0x31, 0x15,
  0x04, 0xc7, 0x23, 0xc3, 0x18, 0x96, 0x05, 0x9a, 0x07, 0x12, 0x80, 0xe2, 0xeb, 0x27, 0xb2, 0x75,
  0x09, 0x83, 0x2c, 0x1a, 0x1b, 0x6e, 0x5a, 0xa0, 0x52, 0x3b, 0xd6, 0xb3, 0x29, 0xe3, 0x2f, 0x84,
  0x53, 0xd1, 0x00, 0xed, 0x20, 0xfc, 0xb1, 0x5b, 0x6a, 0xcb, 0xbe, 0x39, 0x4a, 0x4c, 0x58, 0xcf,
  0xd0, 0xef, 0xaa, 0xfb, 0x43, 0x4d, 0x33, 0x85, 0x45, 0xf9, 0x02, 0x7f, 0x50, 0x3c, 0x9f, 0xa8,
  0x51, 0xa3, 0x40, 0x8f, 0x92, 0x9d, 0x38, 0xf5, 0xbc, 0xb6, 0xda, 0x21, 0x10, 0xff, 0xf3, 0xd2,
  0xcd, 0x0c, 0x13, 0xec, 0x5f, 0x97, 0x44, 0x17, 0xc4, 0xa7, 0x7e, 0x3d, 0x64, 0x5d, 0x19, 0x73,
  0x60, 0x81, 0x4f, 0xdc, 0x22, 0x2a, 0x90, 0x88, 0x46, 0xee, 0xb8, 0x14, 0xde, 0x5e, 0x0b, 0xdb,
  0xe0, 0x32, 0x3a, 0x0a, 0x49, 0x06, 0x24, 0x5c, 0xc2, 0xd3, 0xac, 0x62, 0x91, 0x95, 0xe4, 0x79,
  0xe7, 0xc8, 0x37, 0x6d, 0x8d, 0xd5, 0x4e, 0xa9, 0x6c, 0x56, 0xf4, 0xea, 0x65, 0x7a, 0xae, 0x08,
  0xba, 0x78, 0x25, 0x2e, 0x1c, 0xa6, 0xb4, 0xc6, 0xe8, 0xdd, 0x74, 0x1f, 0x4b, 0xbd, 0x8b, 0x8a,
  0x70, 0x3e, 0xb5, 0x66, 0x48, 0x03, 0xf6, 0x0e, 0x61, 0x35, 0x57, 0xb9, 0x86, 0xc1, 0x1d, 0x9e,
  0xe1, 0xf8, 0x98, 0x11, 0x69, 0xd9, 0x8e, 0x94, 0x9b, 0x1e, 0x87, 0xe9, 0xce, 0x55, 0x28, 0xdf,
  0x8c, 0xa1, 0x89, 0x0d, 0xbf, 0xe6, 0x42, 0x68, 0x41, 0x99, 0x2d, 0x0f, 0xb0, 0x54, 0xbb, 0x16,
]

const INV_SBOX = [
  0x52, 0x09, 0x6a, 0xd5, 0x30, 0x36, 0xa5, 0x38, 0xbf, 0x40, 0xa3, 0x9e, 0x81, 0xf3, 0xd7, 0xfb,
  0x7c, 0xe3, 0x39, 0x82, 0x9b, 0x2f, 0xff, 0x87, 0x34, 0x8e, 0x43, 0x44, 0xc4, 0xde, 0xe9, 0xcb,
  0x54, 0x7b, 0x94, 0x32, 0xa6, 0xc2, 0x23, 0x3d, 0xee, 0x4c, 0x95, 0x0b, 0x42, 0xfa, 0xc3, 0x4e,
  0x08, 0x2e, 0xa1, 0x66, 0x28, 0xd9, 0x24, 0xb2, 0x76, 0x5b, 0xa2, 0x49, 0x6d, 0x8b, 0xd1, 0x25,
  0x72, 0xf8, 0xf6, 0x64, 0x86, 0x68, 0x98, 0x16, 0xd4, 0xa4, 0x5c, 0xcc, 0x5d, 0x65, 0xb6, 0x92,
  0x6c, 0x70, 0x48, 0x50, 0xfd, 0xed, 0xb9, 0xda, 0x5e, 0x15, 0x46, 0x57, 0xa7, 0x8d, 0x9d, 0x84,
  0x90, 0xd8, 0xab, 0x00, 0x8c, 0xbc, 0xd3, 0x0a, 0xf7, 0xe4, 0x58, 0x05, 0xb8, 0xb3, 0x45, 0x06,
  0xd0, 0x2c, 0x1e, 0x8f, 0xca, 0x3f, 0x0f, 0x02, 0xc1, 0xaf, 0xbd, 0x03, 0x01, 0x13, 0x8a, 0x6b,
  0x3a, 0x91, 0x11, 0x41, 0x4f, 0x67, 0xdc, 0xea, 0x97, 0xf2, 0xcf, 0xce, 0xf0, 0xb4, 0xe6, 0x73,
  0x96, 0xac, 0x74, 0x22, 0xe7, 0xad, 0x35, 0x85, 0xe2, 0xf9, 0x37, 0xe8, 0x1c, 0x75, 0xdf, 0x6e,
  0x47, 0xf1, 0x1a, 0x71, 0x1d, 0x29, 0xc5, 0x89, 0x6f, 0xb7, 0x62, 0x0e, 0xaa, 0x18, 0xbe, 0x1b,
  0xfc, 0x56, 0x3e, 0x4b, 0xc6, 0xd2, 0x79, 0x20, 0x9a, 0xdb, 0xc0, 0xfe, 0x78, 0xcd, 0x5a, 0xf4,
  0x1f, 0xdd, 0xa8, 0x33, 0x88, 0x07, 0xc7, 0x31, 0xb1, 0x12, 0x10, 0x59, 0x27, 0x80, 0xec, 0x5f,
  0x60, 0x51, 0x7f, 0xa9, 0x19, 0xb5, 0x4a, 0x0d, 0x2d, 0xe5, 0x7a, 0x9f, 0x93, 0xc9, 0x9c, 0xef,
  0xa0, 0xe0, 0x3b, 0x4d, 0xae, 0x2a, 0xf5, 0xb0, 0xc8, 0xeb, 0xbb, 0x3c, 0x83, 0x53, 0x99, 0x61,
  0x17, 0x2b, 0x04, 0x7e, 0xba, 0x77, 0xd6, 0x26, 0xe1, 0x69, 0x14, 0x63, 0x55, 0x21, 0x0c, 0x7d,
]

const RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]

function xtime(a) {
  return ((a << 1) ^ (((a >> 7) & 1) * 0x1b)) & 0xff
}

function expandKey(key) {
  const w = new Uint8Array(176)
  w.set(key)
  let rconIndex = 1
  for (let i = 16; i < 176; i += 4) {
    let t0 = w[i - 4]
    let t1 = w[i - 3]
    let t2 = w[i - 2]
    let t3 = w[i - 1]
    if (i % 16 === 0) {
      const tmp = t0
      t0 = SBOX[t1] ^ RCON[rconIndex]
      t1 = SBOX[t2]
      t2 = SBOX[t3]
      t3 = SBOX[tmp]
      rconIndex += 1
    }
    w[i] = w[i - 16] ^ t0
    w[i + 1] = w[i - 15] ^ t1
    w[i + 2] = w[i - 14] ^ t2
    w[i + 3] = w[i - 13] ^ t3
  }
  return w
}

function addRoundKey(state, roundKey, offset) {
  for (let i = 0; i < 16; i += 1) {
    state[i] ^= roundKey[offset + i]
  }
}

function subBytes(state) {
  for (let i = 0; i < 16; i += 1) state[i] = SBOX[state[i]]
}

function invSubBytes(state) {
  for (let i = 0; i < 16; i += 1) state[i] = INV_SBOX[state[i]]
}

function shiftRows(state) {
  const s = state.slice()
  state[1] = s[5]
  state[5] = s[9]
  state[9] = s[13]
  state[13] = s[1]
  state[2] = s[10]
  state[6] = s[14]
  state[10] = s[2]
  state[14] = s[6]
  state[3] = s[15]
  state[7] = s[3]
  state[11] = s[7]
  state[15] = s[11]
}

function invShiftRows(state) {
  const s = state.slice()
  state[1] = s[13]
  state[5] = s[1]
  state[9] = s[5]
  state[13] = s[9]
  state[2] = s[10]
  state[6] = s[14]
  state[10] = s[2]
  state[14] = s[6]
  state[3] = s[7]
  state[7] = s[11]
  state[11] = s[15]
  state[15] = s[3]
}

function mixColumns(state) {
  for (let c = 0; c < 4; c += 1) {
    const i = c * 4
    const a0 = state[i]
    const a1 = state[i + 1]
    const a2 = state[i + 2]
    const a3 = state[i + 3]
    const t = a0 ^ a1 ^ a2 ^ a3
    state[i] ^= t ^ xtime(a0 ^ a1)
    state[i + 1] ^= t ^ xtime(a1 ^ a2)
    state[i + 2] ^= t ^ xtime(a2 ^ a3)
    state[i + 3] ^= t ^ xtime(a3 ^ a0)
  }
}

function invMixColumns(state) {
  for (let c = 0; c < 4; c += 1) {
    const i = c * 4
    const a0 = state[i]
    const a1 = state[i + 1]
    const a2 = state[i + 2]
    const a3 = state[i + 3]
    const u = xtime(xtime(a0 ^ a2))
    const v = xtime(xtime(a1 ^ a3))
    state[i] ^= u
    state[i + 1] ^= v
    state[i + 2] ^= u
    state[i + 3] ^= v
  }
  mixColumns(state)
}

function encryptBlock(block, roundKey) {
  const state = block.slice()
  addRoundKey(state, roundKey, 0)
  for (let round = 1; round < 10; round += 1) {
    subBytes(state)
    shiftRows(state)
    mixColumns(state)
    addRoundKey(state, roundKey, round * 16)
  }
  subBytes(state)
  shiftRows(state)
  addRoundKey(state, roundKey, 160)
  return state
}

function decryptBlock(block, roundKey) {
  const state = block.slice()
  addRoundKey(state, roundKey, 160)
  for (let round = 9; round > 0; round -= 1) {
    invShiftRows(state)
    invSubBytes(state)
    addRoundKey(state, roundKey, round * 16)
    invMixColumns(state)
  }
  invShiftRows(state)
  invSubBytes(state)
  addRoundKey(state, roundKey, 0)
  return state
}

function toBytes(text) {
  const bytes = new Uint8Array(text.length)
  for (let i = 0; i < text.length; i += 1) bytes[i] = text.charCodeAt(i)
  return bytes
}

function xorBlock(block, other) {
  const out = new Uint8Array(16)
  for (let i = 0; i < 16; i += 1) out[i] = block[i] ^ other[i]
  return out
}

function pkcs7Pad(bytes) {
  const pad = 16 - (bytes.length % 16)
  const out = new Uint8Array(bytes.length + pad)
  out.set(bytes)
  out.fill(pad, bytes.length)
  return out
}

function pkcs7Unpad(bytes) {
  const pad = bytes[bytes.length - 1]
  if (pad < 1 || pad > 16) throw new Error('invalid padding')
  return bytes.slice(0, bytes.length - pad)
}

function aesCbcEncrypt(plainBytes, keyBytes, ivBytes) {
  const roundKey = expandKey(keyBytes)
  const padded = pkcs7Pad(plainBytes)
  const out = new Uint8Array(padded.length)
  let prev = ivBytes
  for (let offset = 0; offset < padded.length; offset += 16) {
    const block = xorBlock(padded.slice(offset, offset + 16), prev)
    const cipher = encryptBlock(block, roundKey)
    out.set(cipher, offset)
    prev = cipher
  }
  return out
}

function aesCbcDecrypt(cipherBytes, keyBytes, ivBytes) {
  const roundKey = expandKey(keyBytes)
  const out = new Uint8Array(cipherBytes.length)
  let prev = ivBytes
  for (let offset = 0; offset < cipherBytes.length; offset += 16) {
    const cipher = cipherBytes.slice(offset, offset + 16)
    const block = decryptBlock(cipher, roundKey)
    out.set(xorBlock(block, prev), offset)
    prev = cipher
  }
  return pkcs7Unpad(out)
}

function bytesToBase64Url(bytes) {
  let binary = ''
  for (let i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i])
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '')
}

function base64UrlToBytes(code) {
  let base64 = String(code).replace(/-/g, '+').replace(/_/g, '/')
  const pad = base64.length % 4
  if (pad) base64 += '='.repeat(4 - pad)
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i)
  return bytes
}

function bytesToString(bytes) {
  let text = ''
  for (let i = 0; i < bytes.length; i += 1) text += String.fromCharCode(bytes[i])
  return text
}

export async function encryptStaffNo(staffNo) {
  const cipher = aesCbcEncrypt(toBytes(String(staffNo)), toBytes(VCARD_KEY), toBytes(VCARD_IV))
  return bytesToBase64Url(cipher)
}

export async function decryptStaffNo(code) {
  const plain = aesCbcDecrypt(base64UrlToBytes(code), toBytes(VCARD_KEY), toBytes(VCARD_IV))
  return bytesToString(plain)
}

export async function buildVcardLink(staffNo) {
  const code = await encryptStaffNo(staffNo)
  return `https://hr.mcc.sg:10443/vcard/${code}`
}
